import { render } from "./UnitDetailLayout.vue?vue&type=template&id=cd0539be"
import script from "./UnitDetailLayout.vue?vue&type=script&lang=js"
export * from "./UnitDetailLayout.vue?vue&type=script&lang=js"

import "@/css/weeduc/admin/corporate-detail-shared.css?vue&type=style&index=0&lang=css&external"
import "@/css/weeduc/admin/corporate.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__